import { JSX } from 'react';
import { Folder } from 'stockblocks-client';

import { Add } from '@videoblocks/react-icons';

import { triggerEvent } from './FolderSelector';

type FolderAddButtonProps = {
    matchingBins: Folder[];
    searchText: string;
    createNewFolder: (event: triggerEvent) => void;
};

const FolderAddButton = ({ matchingBins, searchText, createNewFolder }: FolderAddButtonProps): JSX.Element => {
    return (
        <>
            {matchingBins.length < 1 && (
                <div
                    role="button"
                    tabIndex={0}
                    id="new-folder-button"
                    className="hover:bg-gray-200 flex-nowrap flex w-full mb-3 cursor-pointer"
                    onClick={createNewFolder}
                    onKeyDown={createNewFolder}
                >
                    <div className="add-new-bin-button inline-flex items-center justify-center w-12 h-12 text-xl bg-yellow-400">
                        <Add className="w-4 h-4" />
                    </div>
                    <div className="grow inline-block ml-3 text-left break-all">{searchText}</div>
                </div>
            )}
        </>
    );
};

export default FolderAddButton;
